/* global __DEV__ */

export default (msg, ...optionalParams) => {
  if (__DEV__ || process.env.TEST) {
    console.log(new Date(), msg, ...optionalParams);
  }
};
